import type { LinkRow } from '@pulse/contracts';
import * as React from 'react';
import { Link } from 'react-router-dom';

import { SourceLink } from '@/components/pulse/source-link';

/**
 * The prototype's `a.attn-item`: a small bordered link with a mono reference, a line of text and
 * a muted note. External links open their source in a new tab; in-app paths stay in Pulse.
 */
export function AttentionItem({ row }: { readonly row: LinkRow }): React.ReactElement {
  const body = (
    <>
      {row.ref !== '' ? (
        <span className="mono" style={{ fontSize: 12, color: 'var(--accent-ink)' }}>
          {row.ref}
        </span>
      ) : null}
      <span>{row.title}</span>
      {row.sub !== null ? <span style={{ fontSize: 12, color: 'var(--muted)' }}>{row.sub}</span> : null}
    </>
  );
  return row.url.startsWith('/') ? (
    <Link className="attn-item" to={row.url}>
      {body}
    </Link>
  ) : (
    <SourceLink className="attn-item" href={row.url}>
      {body}
    </SourceLink>
  );
}
